import { BaseContainerModel } from "../base-container.model";
import { bl_fi_generic_doc_serial_number_swap_request_RowInterface, bl_fi_generic_doc_serial_number_swap_request_RowClass } from "../../dbschema";

export class GenericDocSerialNumberSwapRequestContainerModel extends BaseContainerModel {
  bl_fi_generic_doc_serial_number_swap_request: bl_fi_generic_doc_serial_number_swap_request_RowInterface = new bl_fi_generic_doc_serial_number_swap_request_RowClass();
}
